const EMAIL_RE = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g
const LONG_DIGITS_RE = /\b\d{8,}\b/g
const FORMATTED_PHONE_RE =
  /(?:\+?\d{1,3}[\s.-]?)?(?:\(?\d{2,3}\)?[\s.-]?)?\d{4,5}[\s.-]?\d{4}\b/g

const SENSITIVE_FIELDS = new Set([
  'message',
  'content',
  'body',
  'text',
  'phone',
  'email',
  'name',
])

function normalizedField(key: string) {
  return key.toLocaleLowerCase('en-US').replace(/[^a-z]/g, '')
}

export function scrubPiiString(value: string): string {
  return value
    .replace(EMAIL_RE, '[redacted-email]')
    .replace(FORMATTED_PHONE_RE, '[redacted-phone]')
    .replace(LONG_DIGITS_RE, '[redacted-number]')
}

/**
 * Remove campos semânticos que carregam PII e padrões reconhecíveis dentro
 * dos demais textos. O objeto é alterado in-place para funcionar diretamente
 * nos eventos do Sentry sem criar uma segunda cópia potencialmente sensível.
 */
export function scrubPii<T>(value: T, seen = new WeakSet<object>()): T {
  if (typeof value === 'string') return scrubPiiString(value) as T
  if (!value || typeof value !== 'object') return value
  if (seen.has(value)) return value
  seen.add(value)

  if (Array.isArray(value)) {
    for (let index = 0; index < value.length; index += 1) {
      value[index] = scrubPii(value[index], seen)
    }
    return value
  }

  const record = value as Record<string, unknown>
  for (const key of Object.keys(record)) {
    if (SENSITIVE_FIELDS.has(normalizedField(key))) {
      record[key] = '[redacted]'
    } else {
      record[key] = scrubPii(record[key], seen)
    }
  }
  return value
}
